import { EventEmitter } from "../../common.js";
import { WebWorkerSocket } from "./socket.js";
import { desia } from "sializer";

class inSocket {
  constructor(socket) {
    this.socket = socket;
  }
  send(data) {
    this.socket.emit("message", desia(data));
  }
}

class Socket extends EventEmitter {
  constructor(server) {
    super();
    this.server = server;
    this.inSocket = new inSocket(this);
  }
  register() {}
  connect() {
    this.emit("connect");
  }
  send(data) {
    this.server.handleIncoming(this.inSocket, data);
  }
}

export class Server extends EventEmitter {
  constructor() {
    super();
    this.workers = [];
    this.ready = false;
  }
  kill() {
    for (const worker of this.workers) {
      worker.kill();
    }
  }
  start() {
    this.emit("listening");
    this.ready = true;
  }
  addWorker(worker) {
    const socket = new WebWorkerSocket(worker);
    this.workers.push(socket);
    socket.on("message", (data) => this.handleIncoming(socket, data));
  }
  getTransport() {
    return new Socket(this);
  }
  handleIncoming(socket, data) {
    this.emit("message", socket, Buffer.from(data));
  }
}
